import { useCallback } from 'react';

import { useAuthSession } from '../useAuthSession';

interface SegmentOpts {
    integrations?: any;
    anonymousId?: string | undefined;
    context?: object | undefined;
}

interface UseAnalyticsReturn {
    track: (
        event: string,
        properties?: Object,
        options?: SegmentOpts,
        callback?: () => void,
    ) => void;
}

export default function useAnalytics(): UseAnalyticsReturn {
    const { user: currentUser } = useAuthSession();

    const handleTrack = useCallback(
        (event: string, properties?: Object) => {
            if (!currentUser?.aam) {
                window.analytics.track(event, properties);
            }
        },
        [currentUser],
    );

    return { track: handleTrack };
}
